import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { games, squares, squaresArray } from './squares.model';
// import { SquaresService } from './squares.service';

import { AngularFireAuth } from "@angular/fire/compat/auth";

import { FirebaseFunctions } from '../../shared/firebase/firebasefunctions.service';


@Component({
  selector: 'app-squares',
  templateUrl: './squares.component.html',
  styleUrls: ['./squares.component.scss'],
  providers: [ ]
})
export class SquaresComponent implements OnInit {
  @ViewChild('sidenav') sidenav: any;
  public settings: Settings;
  public userImage = 'assets/img/users/user.jpg';
  // public squaress: Array<Squares>;
  // public talks: Array<Squares>;
  public sidenavOpen:boolean = true;
  // public currentSquares:Squares;
  public newMessage:string;

  
  OneThru9 = [6, 1, 3, 5, 0, 8, 9, 7, 4, 2];
  zeros = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  
  games = games;
  // games;
  squares = squares;
  data;
  data2;
  newData = [];
  updateGames = false;
  updateSquares = false;
  editBoxes = true;
  squaresArray = squaresArray
  
  // gamesId = 'mondaynight2022';
  gamesId = 'superbowl2023';
  // squaresId = 'baxterdads2022';
  squaresId = 'baxterDads2023Superbowl';
  tiles =[]

  constructor(public appSettings:AppSettings, 
    // private squaresService:SquaresService, 
    private ff: FirebaseFunctions, private afAuth: AngularFireAuth,) { 
    this.settings = this.appSettings.settings; 
    


    if (this.updateGames || this.updateSquares) {
      console.log('updating')
      if (this.updateSquares) {
        // console.log('updating squares');
        this.updateSquaresInDb(this.squaresId);
      }
      if (this.updateGames) {
        // console.log('updating games');
        this.updateGamesInDb(this.gamesId);
      }
    }
    else {
      // console.log('running data');
      this.ff.getDataById('squares', this.squaresId)
      .subscribe(data => {
        // console.log(data);
        this.data = data;
        this.squares = this.data.data;
        this.ff.getDataById('games', this.gamesId)
          .subscribe(data2 => {
            // console.log(data2)
            this.data2 = data2;
            this.games = this.data2.data;
            console.log(this.games)
            this.runData();
            // this.getRandomValues();
        });
      });
    }

  }

  ngOnInit() {
    // this.squaress = this.squaresService.getSquaress(); 
    if(window.innerWidth <= 768){
      this.sidenavOpen = false;
    }    
    // this.runData();
  } 


  @HostListener('window:resize')
  public onWindowResize():void {
    (window.innerWidth <= 768) ? this.sidenavOpen = false : this.sidenavOpen = true;
  }

  // public getChat(obj){
  //   if(this.talks){
  //      this.talks.length = 2;
  //   }   
  //   this.talks = this.squaresService.getTalk();
  //   this.talks.push(obj);
  //   this.currentSquares = obj;      
  //   this.talks.forEach(talk => {
  //     if(!talk.my){
  //       talk.image = obj.image;
  //     }
  //   });
  //   if(window.innerWidth <= 768){
  //     this.sidenav.close();
  //   }     
  // }

  // public sendMessage($event) {       
  //   if (($event.which === 1 || $event.which === 13) && this.newMessage.trim() != '') {
  //     if(this.talks){ 
  //       this.talks.push(
  //           new Squares(
  //             'assets/img/users/user.jpg', 
  //             'Emilio Verdines', 
  //             'online', 
  //             this.newMessage,
  //             new Date(), 
  //             true)
  //       )
  //       this.newMessage = '';
  //       let chatContainer = document.querySelector('.chat-content');
  //       if(chatContainer){
  //         setTimeout(() => {
  //           var nodes = chatContainer.querySelectorAll('.mat-list-item');
  //           let newChatTextHeight = nodes[nodes.length- 1];
  //           chatContainer.scrollTop = chatContainer.scrollHeight + newChatTextHeight.clientHeight;
  //         }); 
  //       }
  //     }
  //   }
  // }

  // public ngOnDestroy(){
  //   if(this.talks)
  //     this.talks.length = 2;
  // }

  
  shuffle(array) {
    var i = array.length,
        j = 0,
        temp;

    while (i--) {

        j = Math.floor(Math.random() * (i+1));

        // swap randomly chosen element with current element
        temp = array[i];
        array[i] = array[j];
        array[j] = temp;

    }
    console.log(array)
    return array;
}
// https://stackoverflow.com/questions/18806210/generating-non-repeating-random-numbers-in-js

updateSquaresInDb(id){
    this.ff.createOrUpdateDoc_IfLoggedIn('squares', id, this.squares)
    .subscribe(data => {
      console.log(data);
    });
}

updateGamesInDb(id) {
    this.ff.createOrUpdateDoc_IfLoggedIn('games', id, this.games)
    .subscribe(data => {
      console.log(data);
    });
}

async getRandomValues(){
  let newgames = [];
  for (let i = 0; i < this.games.length; i++) {
    // if (i == 0) {
    //   console.log('skip')
    // }
    // else {

      this.games[i]['xValues'] = this.shuffle(this.games[i]['xValues']);
      this.games[i]['yValues'] = this.shuffle(this.games[i]['yValues']);
    // }
    // this.games[i]['yValues'] = this.zeros;
    // this.games[i]['xValues'] = this.zeros;
    newgames.push(this.games[i])
  }
  // console.log(JSON.stringify(newgames));
  this.runData();
  this.updateGamesInDb(this.gamesId);

}

getRandomValuesSingleGame(week){
  let newgames = [];
  for (let i = 0; i < this.games.length; i++) {
    if (this.games[i].Week == week ) {
      // let newxValues = [...this.OneThru9];
      // let newyValues = [...this.OneThru9];
      // this.games[i]['xValues'] = this.shuffle(newxValues);
      // this.games[i]['yValues'] = this.shuffle(newyValues);
      // newgames.push(this.games[i])
      this.games[i]['xValues'] = this.shuffle(this.games[i]['xValues']);
    this.games[i]['yValues'] = this.shuffle(this.games[i]['yValues']);
    }
  newgames.push(this.games[i])
  }
  this.runData();
  // console.log(JSON.stringify(newgames));
  this.updateGamesInDb(this.gamesId);

}
// this.updateGamesInDb(gamesId);
// need to update games if next year
// to run random comment in line 61/62
// comment out line 83
// comment in line 85
// run, copy console, past in squares.constants.ts

  runData() {
    for (let i = 0; i < this.games.length; i++) {
      const element = this.games[i];
      let newSquares = []
      // element.xValues = this.shuffle(this.OneThru9);
      // element.yValues = this.shuffle(this.OneThru9);
      element.finalScore.HomeTeam = element.finalScore.HomeTeam.toString().slice(-1);
      element.finalScore.AwayTeam = element.finalScore.AwayTeam.toString().slice(-1);
      element.newSquareData = this.squares
      for (let j = 0; j < this.squares.length; j++) {
        const squares = this.squares[j];
        
        // const id = element.yValues[j]
    
        // const val2 = {
        //   "id": element.yValues[j],
        // }
        // for (let h = 0; h < this.squaresArray.length; h++) {
        //   const elementSquare = this.squaresArray[h];
        //   // console.log(elementSquare.Row == element.yValues[j] )
        //   if (elementSquare.Row == element.yValues[j] ) {
        //   for (let e = 0; e < 10; e++) {
        //     // console.log(elementSquare.Squares, element.yValues[e])
        //       // && elementSquare.Squares == element.yValues[0])
        //       val2[element.yValues[e]] = elementSquare.Name
        //     }
        //   }
          
        // }

        const val = {
          "id": element.yValues[j],
          [element.yValues[0]]: squares["0"],
          [element.yValues[1]]: squares["1"],
          [element.yValues[2]]: squares["2"],
          [element.yValues[3]]: squares["3"],
          [element.yValues[4]]: squares["4"],
          [element.yValues[5]]: squares["5"],
          [element.yValues[6]]: squares["6"],
          [element.yValues[7]]: squares["7"],
          [element.yValues[8]]: squares["8"],
          [element.yValues[9]]: squares["9"],
        }
        newSquares.push(val)
      }
    element.newSquareData = newSquares
  }
  // console.log(JSON.stringify(games));
  // console.log(JSON.stringify(newgames));


  }
   // TODO if date past date of game (or a few days after) then remove game from rendering
  // TODO set up auto way to randomize numbers
  // TODO set up way to auto pull in games
  // TODO set up way for people to buy squares and dynamically assign squares

}